import { useQuery } from "react-query";
import { BahasaResponse } from "../../../../models/Bahasa";
import { getApiInstance } from "../../../api";
import ApiClient from "../../../apiClient";
import queryWrapper from "../../queryWrapper";

export const allBahasaKey = "all-bahasa-key";

export async function allBahasa(): Promise<BahasaResponse[]> {
  const res = await ApiClient.get(`/AllBahasa`);
  return res.data;
}

export default function useFetchAllBahasa() {
  return useQuery([allBahasaKey], queryWrapper(allBahasa));
}
